import JsxBindClassMetadata from "./JsxBindClassMetadata";

export default class JsxBindReflectMetadata {

    private static instance: JsxBindReflectMetadata;

    private _map: WeakMap<any, JsxBindClassMetadata> = new WeakMap();

    private constructor() {}

    static getInstance(): JsxBindReflectMetadata {
        if (!JsxBindReflectMetadata.instance) {
            JsxBindReflectMetadata.instance = new JsxBindReflectMetadata();
        }

        return JsxBindReflectMetadata.instance;
    }

    public bindDecorator(ref: string, single: boolean){
        return function (target: Object, propertyKey: string|symbol): void{
            if(JsxBindReflectMetadata.isSymbol(propertyKey)){
                return;
            }

            console.log("BIND KEY", target);

            JsxBindReflectMetadata.getInstance().put(target, ref, <string>propertyKey, single);
        };
    }

    public put(object:any, ref: string, property: string, single: boolean){
        if(!JsxBindReflectMetadata.isObject(object)){
            return;
        }

        if(!this._map.has(object)){
            this._map.set(object, new JsxBindClassMetadata());
        }

        if(single) {
            this._map.get(object).addSingle(ref, property);
        }else{
            this._map.get(object).addArr(ref, property);
        }
    }


    get map(): WeakMap<any, JsxBindClassMetadata> {
        return this._map;
    }

    public getMetadata(obj:any): JsxBindClassMetadata{

        if(JsxBindReflectMetadata.isObject(obj)){

            console.log("OBJECT in get meta");
            let key = Object.getPrototypeOf(obj);

            if(this._map.has(key)){
                return this._map.get(key);
            }
        }

        return new JsxBindClassMetadata();
    }

    public static isObject(x:any) {
        return typeof x === "object" ? x !== null : typeof x === "function";
    }

    public static isSymbol(x: any) {
        return typeof x === "symbol";
    }

}